import { useTranslation } from '@wix/wix-i18n-config';
import React, { FC } from 'react';

import { TLocalesKeys as K } from '../../../../types';
import { IWaitingForAgent } from '../../../common/messageCreators/waitingForAgent';
import { MessageItem } from '../MessageItem';
import { Line } from './Line';

export const WaitingForAgent: FC<IWaitingForAgent> = ({ id }) => {
  const { t } = useTranslation();

  const key: K = 'live_chat_start';
  const message = t<K>(key);

  return (
    <MessageItem id={id} width="full">
      <Line>{message}</Line>
    </MessageItem>
  );
};
